import { queryOptions, useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type SubscriptionFeature = {
    featureId: string
    featureKey: string
    description: string
    unit: string
    planFeatures: (unknown | null)[]
}

export type PlanFeature = {
    planId: string
    featureId: string
    limitType: string
    limitInt: number
    limitDecimal: number
    resetPeriod: string
    pooledScope: string
    rollover: string
    gracePercent: number
    throttleAfter: number
    feature: SubscriptionFeature
}

export type SubscriptionPlan = {
    planId: string
    planSku: string
    name: string
    description: string
    billingInterval: string
    isAddon: boolean
    createdAt: string
    updatedAt: string
    planFeatures: PlanFeature[]
}

export type SubscriptionItem = {
    subscriptionItemId: string
    subscriptionId: string
    planId: string
    quantity: number
    isBasePlan: boolean
    metered: boolean
    createdAt: string
    updatedAt: string
    plan: SubscriptionPlan
}

export type SubscriptionCore = {
    subscriptionId: string
    accountId: string
    scope: string
    storeId: string
    source: string
    partnerId: string
    chargebeeSubscriptionId: string
    status: string
    primaryFlag: boolean
    startAt: string
    currentPeriodStart: string
    currentPeriodEnd: string
    renewalAt: string
    trialEndAt: string
    cancelAt: string
    canceledAt: string
    createdAt: string
    updatedAt: string
}

export type SubscriptionResponse = {
    subscription: SubscriptionCore
    items: SubscriptionItem[]
}

export const getSubscription = (id: string): Promise<SubscriptionResponse> => {
    return api.get(`v2/subscriptions/${id}`)
}

export const getSubscriptionQueryOptions = (id: string) =>
    queryOptions({ queryKey: ['subscriptions', id], queryFn: () => getSubscription(id) })

type UseSubscriptionOptions = { subscriptionId: string; queryConfig?: QueryConfig<typeof getSubscription> }

export const useSubscription = ({ subscriptionId, queryConfig }: UseSubscriptionOptions) => {
    return useQuery({
        ...getSubscriptionQueryOptions(subscriptionId),
        ...queryConfig,
    })
}


